// extracted by mini-css-extract-plugin
export default {"readContent":"Hero_readContent__cCVFw","itemPlusMinus":"Hero_itemPlusMinus__pneMl","separateCode":"Hero_separateCode__Z2d+c","spaceIcon":"Hero_spaceIcon__-u7yY"};